export default __webpack_public_path__ + "static/media/MeyerLogo-80h.f889bec4.png";